import { create } from "zustand";

interface AddSiteOnboardingState {
  needsWireGuardOnboarding: boolean;
  setNeedsWireGuardOnboarding: (value: boolean) => void;
  selectedWireGuardServer: string | null;
  setSelectedWireGuardServer: (value: string | null) => void;
  resetOnboarding: () => void;
}

export const useAddSiteOnboardingStore = create<AddSiteOnboardingState>(
  (set) => ({
    needsWireGuardOnboarding: false,
    setNeedsWireGuardOnboarding: (value: boolean) =>
      set({ needsWireGuardOnboarding: value }),
    selectedWireGuardServer: null,
    setSelectedWireGuardServer: (value: string | null) =>
      set({ selectedWireGuardServer: value }),
    resetOnboarding: () =>
      set({ needsWireGuardOnboarding: false, selectedWireGuardServer: null }),
  })
);
